import { useState } from 'react'
import { Button, Group, TextInput } from '@forwardflow/ui-v2'
import { PhoneIcon } from '@forwardflow/icons'
import { TFubUser } from '@forwardflow/types/onboarding'
import { useOnboardingStoreV2 } from '@forwardflow/store/onboardingStoreV2'

interface PhoneNumberChangeProps {
   fubUser: Partial<TFubUser>
   setEditOwnerUser: (value: boolean) => void
   setFubUser: (value: Partial<TFubUser>) => void
}

export const PhoneNumberChange = ({
   fubUser,
   setEditOwnerUser,
   setFubUser,
}: PhoneNumberChangeProps) => {
   const [editOwnerUserPhone, setEditOwnerUserPhone] = useState<boolean>(false)
   const { onboardingData, setInvitedUsers } = useOnboardingStoreV2()
   const { invitedUsers } = onboardingData
   const [phoneNumber, setPhoneNumber] = useState<string>(fubUser?.phone || '')

   const handleConfirmPhone = () => {
      setFubUser({
         ...fubUser,
         phone: phoneNumber,
      })
      setInvitedUsers(
         invitedUsers?.map((user: TFubUser) => {
            if (String(user.id) === String(fubUser?.id) && user.isOwner) {
               return {
                  ...user,
                  phone: phoneNumber,
               } as TFubUser
            }
            return user
         })
      )
      setEditOwnerUserPhone(false)
   }

   const handleCancelEdit = () => {
      setEditOwnerUserPhone(false)
      setPhoneNumber(fubUser?.phone || '')
   }

   return (
      <div className="rounded-[8px] border border-white/20 bg-white/[0.02]">
         <Group
            justify="space-between"
            className="border-b border-white/20 p-4"
         >
            <span className="text-white/90 text-sm font-medium">
               {fubUser?.email}
            </span>
            {!onboardingData?.isOnBoardingCompleted && (
               <span
                  className="text-[#99A1AF] text-sm font-medium cursor-pointer"
                  onClick={() => {
                     setEditOwnerUser(true)
                     setFubUser({})
                  }}
               >
                  Not you?
               </span>
            )}
         </Group>
         <Group justify="space-between" className="p-4">
            {editOwnerUserPhone ? (
               <div className="grid grid-cols-[1fr_100px_100px] gap-2 w-full items-center">
                  <TextInput
                     placeholder="Enter your Phone Number"
                     value={phoneNumber}
                     onChange={(e) => setPhoneNumber(e.target.value)}
                  />
                  <Button
                     className="w-full"
                     size="middle"
                     onClick={handleConfirmPhone}
                  >
                     Confirm
                  </Button>
                  <Button
                     variant="secondary"
                     className="w-full"
                     size="middle"
                     onClick={handleCancelEdit}
                  >
                     Cancel
                  </Button>
               </div>
            ) : (
               <>
                  <Group>
                     <PhoneIcon className="w-5" color="#A684FF" />
                     <span className="text-white/90 font-medium">
                        {fubUser?.phone}
                     </span>
                  </Group>
                  <span
                     className="text-[#99A1AF] text-sm font-medium cursor-pointer"
                     onClick={() => setEditOwnerUserPhone(true)}
                  >
                     Change Phone Number
                  </span>
               </>
            )}
         </Group>
      </div>
   )
}
